import { listProductCategory } from "./mock/mockData";

const actions = {
  async listPolicies(context, payload) {
    try {
      const response = await this.$api.call("qapp_my.list", payload);
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPolicies", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPolicies", responseData);
      }

      context.commit("mutationPoliciesMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationPolicies", []);
      context.commit("mutationPoliciesMeta", {});

      throw error;
    }
  },

  async listPartner(context, payload) {
    try {
      const response = await this.$api.call("qapp_my.insurer", payload);
      const responseData = response.data;

      context.commit("mutationPartners", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPartners", []);
      throw error;
    }
  },

  async listProductCategory(context) {
    try {
      // TODO: hide for temporary, needs to hardcode for personal lines category
      // const response = await this.$api.call('pl_endorsement.productCategories', payload);
      const response = listProductCategory;
      context.commit("mutationProductCategories", response.data);
      return response;
    } catch (error) {
      context.commit("mutationProductCategories", {});
      throw error;
    }
  },

  async downloadListPolicies(_context, payload) {
    try {
      const response = await this.$api.call("qapp_my.export", payload);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default actions;
